/* eslint-disable react/prop-types */
import { forwardRef, memo, useEffect, useState, useMemo } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { MathJax } from 'better-react-mathjax';

import Typography from 'components/Typography';
import Input from 'components/InputMinimalis';
import clsx from 'libs/clsx';
import useTemplateRenderer from 'hooks/useTemplateRenderer';
import useReplacer from 'hooks/useReplacer';

const ISIAN_PATTERN = /<@isian>/gi;

function ExamFillMinimalis(
  { question: { id, question }, answer, onAnswerChange },
  ref // eslint-disable-line no-unused-vars
) {
  const replacer = useReplacer();
  const questionIsian = useTemplateRenderer(
    replacer.examText(question),
    ISIAN_PATTERN
  );

  // Isi dari textarea.
  const [answers, setAnswers] = useState([]);

  // Jumlah dari textarea yang tersedia.
  const columnTotal = useMemo(
    () => (question.match(ISIAN_PATTERN) || []).length,
    [question]
  );

  const handleChange = (inputIndex, value) => {
    setAnswers((currentAnswers) =>
      currentAnswers.map((currentAnswer, index) =>
        index === inputIndex ? value : currentAnswer
      )
    );
  };

  // Mengubah jawaban saat ada event onblur.
  const handleBlur = () => {
    const newAnswer = answers
      .map((_answer) => _answer || '')
      .filter((v, i) => i < columnTotal)
      .join('|');

    const areAllInputEmpty =
      answers.filter((_answer) => _answer !== '').length === 0;
    const sanitizedNewAnswer = areAllInputEmpty ? ' ' : newAnswer;

    if (answer !== sanitizedNewAnswer) {
      onAnswerChange(sanitizedNewAnswer);
    }
  };

  // Mereset value apabila jawabannya direset.
  useEffect(() => {
    if (answer === ' ') {
      setAnswers(new Array(columnTotal).fill(''));
    }
  }, [answer, columnTotal]);

  // Menangani agar kolom jawaban otomatis terisi jika peserta sudah menjawab.
  useEffect(() => {
    if (answer === ' ') {
      setAnswers(new Array(columnTotal).fill(''));
    } else {
      const answerArray = answer.split('|');

      if (answerArray.length < columnTotal) {
        setAnswers(new Array(columnTotal).fill(''));
      } else {
        setAnswers(answerArray);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // const questionArabic = /[\u0600-\u06FF]/.test(question);

  return (
    <Typography
      as="div"
      className={clsx('font-readable select-none mt-5')}
      gutterBottom
    >
      <MathJax>
        {/* Merender HTML */}
        {ReactHtmlParser(questionIsian.html, {
          // Melakukan transformasi terhadap elemen
          // eslint-disable-next-line consistent-return
          transform: (node) => {
            if (questionIsian.match(node)) {
              const index = questionIsian.indexOf(node);

              // Jawaban peserta berdasarkan index.
              // Jawaban yang dipilih pada kolom jawaban index ini.
              const currentAnswer = answers[index];

              return (
                <Input
                  as="input"
                  id={`fill-${index}`}
                  name={`fill-${index}`}
                  label=""
                  value={currentAnswer}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onBlur={handleBlur}
                  className="mb-5"
                />
              );
            }
          },
        })}
      </MathJax>
    </Typography>
  );
}

ExamFillMinimalis = forwardRef(ExamFillMinimalis);

export default memo(ExamFillMinimalis);
